import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import iconSprite from '../../../assets/icon-sprite.svg';
import { cancelLoan } from '../../actions/p2p';

class CancelLoan extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleOnSubmit = async (e) => {
    e.preventDefault();
    const { onClose, onSubmit, data } = this.props;
    const { reason } = this.state;
    this.setState({ loading: 'Processing' }, async () => {
      try {
        const response = await cancelLoan(data.id, reason);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        window.location.reload(false);
        onClose?.();
        onSubmit?.();
      } catch (error) {
        this.setState({ loading: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { visible, onClose = function $() { } } = this.props;
    const { loading } = this.state;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <form
          className="modal-form"
          onSubmit={this.handleOnSubmit}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteCustomerLabel">Cancel Loan?</h5>
              <button type="button" className="close" onClick={onClose}>
                <svg width="48" height="48">
                  <use xlinkHref={iconSprite + '#close-icon'}></use>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-body_message d-flex text-center justify-content-center align-items-center flex-column">
                <p>
                  Are you sure you want to cancel this loan?
                </p>
                <div className="form-group">
                  <label htmlFor="reason" className="form-label">Enter a reason:</label>
                  <textarea name="reason" id="reason" className="form-control" onChange={this.handleOnChange}
                    required rows="15" cols="100"></textarea>
                
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary">
                {loading || 'Cancel Loan'}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default CancelLoan;
